import {
	IModel,
	db,
	VIPCapability,
	IVIPCapability,
	IVIPCapabilityOptions,
	VIPCertificate,
	IVIPCertificate,
	IVIPCertificateOptions,
} from "@/loader";

export type VIPCapabilityCertificateFields = "fk_capability" | "fk_certificate";

/**
 * Capability Certificate Base Interface.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * Do not modify it because it will be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		1.2.2
 * @since		1.0.0
 */
export interface IVIPCapabilityCertificateBase {
	/** Capability ID */
	fk_capability?: number;
	/** Certificate ID */
	fk_certificate?: number;

	/** Capability */
	capability?: IVIPCapability | null;
	/** Certificate */
	certificate?: IVIPCertificate | null;
}

/**
 * Capability Certificate Base Options Interface.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * Do not modify it because it will be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		1.2.2
 * @since		1.0.0
 */
export interface IVIPCapabilityCertificateOptions {
	/** Indicates whether the Capability ID should be included or not. Default true. */
	fk_capability?: boolean;
	/** Indicates whether the Certificate ID should be included or not. Default true. */
	fk_certificate?: boolean;
	/** Indicates whether the Capability should be included or not. Default false. */
	capability?: boolean | IVIPCapabilityOptions;
	/** Indicates whether the Certificate should be included or not. Default false. */
	certificate?: boolean | IVIPCertificateOptions;
}

/**
 * Capability Certificate Base Class Logic.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * Do not modify it because it will be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		1.2.2
 * @since		1.0.0
 */
export class VIPCapabilityCertificateBase implements IVIPCapabilityCertificateBase, IModel<IVIPCapabilityCertificateBase> {
	/** Capability ID */
	public fk_capability!: number;
	/** Certificate ID */
	public fk_certificate!: number;

	/**
	 * Get Capability
	 */
	public get capability(): VIPCapability | null {
		return db.capabilities.get(this.fk_capability);
	}

	/**
	 * Set Capability
	 */
	public set capability(value: VIPCapability | null) {
		this.fk_capability = Number.orDefault(value?.id);
	}

	/**
	 * Get Certificate
	 */
	public get certificate(): VIPCertificate | null {
		return db.certificates.get(this.fk_certificate);
	}

	/**
	 * Set Certificate
	 */
	public set certificate(value: VIPCertificate | null) {
		this.fk_certificate = Number.orDefault(value?.id);
	}

	/**
	 * Constructor.
	 * @param data
	 */
	constructor (data: IVIPCapabilityCertificateBase = {}) {
		this.load(data);
	}

	/**
	 * Set all properties with the data provided or a default value.
	 *
	 * All properties will be set, either with the value provided or with their default value.
	 *
	 * If you want to set only a subset of this instance's properties, use {@link VIPCapabilityCertificateBase.update} instead.
	 *
	 * @param data
	 */
	public load(data: IVIPCapabilityCertificateBase) {
		this.fk_capability = Number.orDefault(data.fk_capability);
		this.fk_certificate = Number.orDefault(data.fk_certificate);
		if (data.capability) {
			db.capabilities.insertOrUpdate(data.capability);
		}
		if (data.certificate) {
			db.certificates.insertOrUpdate(data.certificate);
		}
	}

	/**
	 * Set the properties with the data provided.
	 *
	 * Only the properties defined in data will be updated. Falsy values will be treated, only `undefined` is not.
	 *
	 * If you want to redefine all properties, use {@link VIPCapabilityCertificateBase.load} instead.
	 *
	 * @param data
	 */
	public update(data: IVIPCapabilityCertificateBase) {
		if (data.fk_capability !== undefined) {
			this.fk_capability = Number.orDefault(data.fk_capability);
		}
		if (data.fk_certificate !== undefined) {
			this.fk_certificate = Number.orDefault(data.fk_certificate);
		}
		if (data.capability) {
			db.capabilities.insertOrUpdate(data.capability);
		}
		if (data.certificate) {
			db.certificates.insertOrUpdate(data.certificate);
		}
	}
}
